export default "__VITE_ASSET__CvzBh_$4__"